export interface IVerifyHOTPInput {
    secret: string;
    token: string;
}
